<template>
  <div class="signIn">
    <div class="finger">
        <span class="icon-fingerprint"></span>
    </div>
    <div class="dayWrapper">
      <div class="day">每日签到</div>
      <div class="mark">连续签到7天有惊喜</div>
      <div class="loopDay">
        <ul class="loopDay_ul">
          <li class="loopDay_li" v-for="(day,index) in days">
            <span :class='changeLoopSign[index]==1?"doData":"data"'>{{day}}</span>
            <span class="do" :class='changeLoopSign[index]==1?"icon-right":""'></span>
          </li>

        </ul>
      </div>
    </div>
    <div class="signBtn":class='changeHasSign?"aready":""' @click="signIn">{{changeHasSign?"已签到":"签到"}}</div>
  </div>
</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
  export default {
    name:"signIn",
    data(){
      return{
        hasSign:JSON.parse(this.$store.getters.getHasSign),
        loopSign:this.$store.getters.getLoopSign,
        days:[1,2,3,4,5,6,7]
      }
    },
    created(){
      console.log(this.loopSign)
    },
    methods:{
      signIn: function(){
        this.$store.dispatch('signIn')
      }
    },
    computed: {
      changeLoopSign:function(){
        return this.$store.getters.getLoopSign
      },
      changeHasSign:function(){
        return JSON.parse(this.$store.getters.getHasSign)
      }
    }
  }
</script>
<style lang="stylus">
  .signIn
    width:710px
    height:200px
    background:#ffffff
    box-sizing:border-box
    display:flex
    padding:0 50px 0 55px
    border-radius:20px
    position:absolute
    bottom:-120px
    left:20px
    display:flex
    align-items:center
    .finger
      flex:0 0 86px
      width:86px
      height:86px
      border-radius:43px
      background:#fffae5
      text-align:center
      line-height:80px
      color:#ff6c25
      font-size:60px
      padding-top:6px
      box-sizing:border-box
    .dayWrapper
      flex:1
      padding-left:30px
      .day
        font-size:30px
        color:#333
      .mark
        font-size:24px
        color:#808080
        margin-top:5px
      .loopDay_ul
        display:flex
        margin-top:10px
        .loopDay_li
          flex:0 0 40px
          padding-right:10px
          box-sizing:border-box
          font-size:0
          text-align:center
          .doData,.data
            width:30px
            height:30px
            font-size:20px
            text-align:center
            display:inline-block
            border-radius:15px
            box-sizing:border-box
            &.doData
              background:#ffb104
              color:#fff
            &.data
              background:#fffae5
              color:#ffba10
              border:1px solid #ffba10
              /*px*/
          .do
            color:#00c700
            font-size:5px
            margin-top:5px
    .signBtn
      width:128px
      flex:0 0 128px
      height:56px
      line-height:56px
      box-sizing:border-box
      border:2px solid #ff6c25
      /*px*/
      border-radius:28px
      text-align:center
      font-size:30px
      line-height:56px
      color:#ff6c25
      &.aready
        background:#ff6c25
        color:#fff

</style>



// WEBPACK FOOTER //
// src/components/userCenter/userCenter/SignIn.vue